"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighStakesAbilityHandler = exports.HighStakesActorAbilityFactory = exports.HighStakesAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/actions/core");
const Random_1 = require("../../utils/Random");
class HighStakesAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HighStakes;
        this.__typeName = "HighStakes";
    }
}
exports.HighStakesAbilityArgs = HighStakesAbilityArgs;
let HighStakesActorAbilityFactory = class HighStakesActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HighStakes", "OneEnemies", 2);
    }
};
HighStakesActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HighStakes")
], HighStakesActorAbilityFactory);
exports.HighStakesActorAbilityFactory = HighStakesActorAbilityFactory;
let HighStakesAbilityHandler = class HighStakesAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "WhiteCloud",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Chaos", 100)
            ],
            onHitOrMiss: sequence => {
                if (container.isDeceased(selectedEnemy)) {
                    return;
                }
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId: selectedEnemy,
                    amount: container.getPercentOfBaseHealth(selectedEnemy, 25),
                    onApplied: sequence => container.dispatch(sequence, selectedEnemy, new core_1.SpeakTextActionArgs("Better luck next time!"))
                });
            },
            onHit(sequence) {
                if (!container.isDeceased(selectedEnemy)) {
                    return;
                }
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => {
                    container.applyHealing({
                        sequence,
                        healerId: ability.invokerId,
                        targetId: allyId,
                        amount: container.getPercentOfBaseHealth(allyId, 25),
                        onApplied: sequence => container.dispatch(sequence, selectedEnemy, new core_1.SpeakTextActionArgs((0, Random_1.randomElement)([
                            "That's the good stuff.",
                            "High risk, High reward!",
                            "Didn't see that coming.",
                            "Hit!"
                        ])))
                    });
                });
            }
        });
    }
};
HighStakesAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HighStakes)
], HighStakesAbilityHandler);
exports.HighStakesAbilityHandler = HighStakesAbilityHandler;
